import { periodFormat } from 'utils/common';

export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      occurredDate: periodFormat(filter.occurredDate),
      accountManager: filter.accountManager[0] ? filter.accountManager : '*',
      customerSuccessEngineer: filter.customerSuccessEngineer[0]
        ? filter.customerSuccessEngineer
        : '*',
      sentiment: filter.sentiment[0] ? filter.sentiment : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
